<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 1.1
    </div>

  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>




// WEBPACK FOOTER //
// src/temp/partials/Footer.vue